// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__33vTP","ripple":"styles_ripple__cs8Tm","label":"styles_label__1pgHA"};